module.exports = window["__sharedEmotionReact"];